import { useMemo } from 'react';

/**
 * Search, sort and filter the manual screen's `[{ goal, pinned }]` list by the `SessionFilters`
 * state (search, sortBy, sort, domain, type, mode, tag). Same rules as the live session screen
 * (`session.js`), kept here so manual entry does not touch the live session code.
 */
export const useManualGoalFilters = (goals, filters) => {
    const listData = useMemo(() => {
        if (!goals) return [];
        let list = [...goals];
        const searchText = filters?.search?.trim();
        if (searchText) {
            const search = searchText.toLowerCase();
            list = list.filter((item) => item.goal.name.toLowerCase().includes(search));
        }

        const sortBy = filters?.sortBy;
        if (sortBy === 'nameAsc') {
            list.sort((a, b) => a.goal.name.trim().localeCompare(b.goal.name.trim()));
        } else if (sortBy === 'nameDesc') {
            list.sort((a, b) => b.goal.name.trim().localeCompare(a.goal.name.trim()));
        } else if (sortBy === 'mostTrials') {
            list.sort((a, b) => (b.goal?.targets?.length || 0) - (a.goal?.targets?.length || 0));
        } else if (sortBy === 'leastTrials') {
            list.sort((a, b) => (a.goal?.targets?.length || 0) - (b.goal?.targets?.length || 0));
        } else if (filters?.sort) {
            list.sort((a, b) => {
                const nameA = a.goal.name.trim();
                const nameB = b.goal.name.trim();
                return filters?.sort === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
            });
        }

        return list;
    }, [goals, filters?.sort, filters?.search, filters?.sortBy]);

    return useMemo(() => {
        let arr = [...listData];
        if (filters?.domain?.length > 0) {
            arr = arr.filter((item) => Boolean(filters.domain.find((d) => d === item.goal.domain?.id)));
        }
        if (filters?.type?.length > 0) {
            arr = arr.filter((item) => filters.type.includes(item.goal.type));
        }
        if (filters?.mode?.length > 0) {
            arr = arr.filter((item) => filters.mode.includes(item.goal.dataType));
        }
        if (filters?.tag?.length > 0) {
            arr = arr.filter((item) => (item.goal.tags || []).some((t) => filters.tag.includes(t.id)));
        }
        return arr;
    }, [listData, filters]);
};
